module.exports = __webpack_public_path__ + "img/jcps-logo.41289819.jpg";